<div [class.two-column-tool-tip]="_showInfo">
    <mat-form-field appearance="fill" [class.small]="_short" [class.mat-form-field-invalid]="true">
        <mat-label>{{ _labelData.label }}</mat-label>
        <textarea matInput type="text" [name]="_name" [required]="true" rows="8" [disabled]="_disabled || _readOnly"#name="ngModel" [errorStateMatcher]="_matcher" (ngModelChange)="valueUpdated($event)" [(ngModel)]="_value"></textarea>
        @if (_showValidationError) {
            <mat-error>{{_labelData.validationErrorText}}</mat-error>
        }
    </mat-form-field> 
    @if (_showInfo) {
        <mat-icon color="primary" [matTooltip]="_toolTip" #tooltip="matTooltip" (click)="tooltip.toggle()">info</mat-icon>
    }
</div>